import React, { Fragment } from 'react';
import styles from '../../views/Pricing/components/FeaturesChecklist/features-checklist.css';

export const featureChecklist = [
    [
        {
            name: 'Mobile + Desktop Apps',
            tooltip: 'Stay connected with Grasshopper on your desktop, iPhone or Android device.'
        },
        {
            name: 'Business Phone Number*',
            tooltip: 'Choose from our inventory of vanity, local, or toll-free numbers. Or port your own for free!'
        },
        {
            name: 'Business Texting',
            tooltip: 'Provide updates and quick replies via text messaging on your business number.'
        },
        {
            name: 'Call Forwarding',
            tooltip: 'Route business calls to your personal phone or to another team member.'
        },
        {
            name: 'VoIP + WiFi Calling',
            tooltip: 'Use your internet connection to make and receive calls when cell reception is poor.'
        },
        {
            name: 'Virtual Fax',
            tooltip: 'Have incoming faxes delivered as PDF attachments right to your email inbox.'
        },
        {
            name: 'Voicemail',
            tooltip: 'Set up a voicemail for business calls and get MP3s of your messages through email.'
        },
        {
            name: 'Read Your Voicemail',
            tooltip: 'Get your voicemails transcribed so you can read them without having to listen to the message!'
        }
    ],
    [
        {
            name: 'Extensions',
            tooltip: 'Give employees or departments extensions with their own call forwarding rules.'
        },
        {
            name: 'Instant Response',
            tooltip: 'Automatically send a text to new callers when you can’t answer their call.'
        },
        {
            name: 'Custom Greetings',
            tooltip: 'Record professional messages that welcome your customers when they call.'
        },
        {
            name: 'Call Transfers',
            tooltip: 'Place callers on hold and even transfer them to another number when needed.'
        },
        {
            name: 'Simultaneous Call Handling',
            tooltip: 'Ensure that your callers never hear a busy signal.'
        },
        {
            name: 'Incoming Call Control',
            tooltip: 'Screen callers, block calls and set up custom schedules for your business hours.'
        },
        {
            name: 'Reporting',
            tooltip: 'Keep your finger on the pulse of your business with detailed call reports.'
        }
    ]
];

export const basicFeatures = [
    {
        name: 'Unlimited Minutes',
        tooltip: 'Use as many minutes as you want.'
    },
    {
        name: 'Business Texting',
        tooltip: 'Provide updates and quick replies via text messaging on your business number.'
    },
    {
        name: 'Voicemail',
        tooltip: 'Set up a voicemail for business calls and get MP3s of your messages through email.'
    },
    {
        name: 'Main Greetings',
        tooltip: 'Record professional messages that welcome your customers when they call.'
    },
    {
        name: 'Mobile and Desktop Apps',
        tooltip: 'Stay connected with Grasshopper on your desktop, iPhone or Android device.'
    },
    {
        name: 'WiFi and VoIP Calling',
        tooltip: 'Use your internet connection to make and receive calls when cell reception is poor.'
    },
    {
        name: 'Spam Detection',
        tooltip: 'Stay productive, by ignoring calls that are likely spam (WiFi calling only).'
    },
    {
        name: '24/7 US-Based Support',
        tooltip: 'Contact our US-based customer support team to help with any questions!'
    }
];

export const premiumFeatures = [
    {
        name: 'Call Transferring',
        tooltip: 'Place callers on hold and even transfer them to another number when needed.'
    },
    {
        name: 'Voicemail Transcription',
        tooltip: 'Get your voicemails transcribed so you can read them without having to listen to the message!'
    },
    {
        name: 'Business Hour Scheduling',
        tooltip: 'Set up a call schedule so you get calls only when you want them.'
    },
    {
        name: 'Scheduling by Extension',
        tooltip: 'Set up a call schedule by individual extensions so people can take calls after hours.'
    },
    {
        name: 'Call Blocking',
        tooltip: 'Block calls from numbers that you define.'
    },
    {
        name: 'Instant Response Texting',
        tooltip: 'Automatically send a text to new callers when you can’t answer their call.'
    },
    {
        name: 'Virtual Fax',
        tooltip: 'Have incoming faxes delivered as PDF attachments right to your email inbox.'
    },
    {
        name: 'Simultaneous Call Handling',
        tooltip: 'Ensure that your callers never hear a busy signal.'
    }
];

export const platiumFeatures = [
    {
        name: 'Reporting',
        tooltip: 'Keep your finger on the pulse of your business with detailed call reports.'
    },
    {
        name: 'Professional Voice Studio (a $75 value!)',
        tooltip: 'Write your greeting script and have it recorded by a professional voice actor. (Includes 1 free voice studio order.)'
    },
    {
        name: 'Call Blasting',
        tooltip: 'Ring all of your call forwarding numbers simultaneously, to reduce wait times for your callers and reach your first available team member. (A $10/mo value.)'
    },
    {
        name: 'Discounted Virtual Meeting Tools (a $120 value)',
        tooltip: 'Connect with clients or prospective customers via join.me, which offers video online meetings, screen-sharing, and conference calling. (Take 50% off a full-year subscription to join.me.) '
    }
];

export const getFeaturesChecklist = (isPircingPageVariantTest) => {
    if (isPircingPageVariantTest) {
        return [
            [
                {
                    name: 'Virtual Voicemail',
                    tooltip: 'Set up a voicemail for business calls and get MP3s of your messages through email.'
                },
                {
                    name: 'Call Forwarding',
                    tooltip: 'Route business calls to your personal phone or to another team member.'
                },
                {
                    name: 'VoIP + WiFi Calling',
                    tooltip: 'Use your internet connection to make and receive calls when cell reception is poor.'
                },
                {
                    name: 'Virtual Fax',
                    tooltip: 'Have incoming faxes delivered as PDF attachments right to your email inbox..'
                }
            ],
            [
                {
                    name: 'Virtual Receptionist',
                    tooltip: 'Live US-based receptionists can help answer your Grasshopper calls.'
                },
                {
                    name: 'Address Book',
                    tooltip: "See your contacts' names for calls and text messages in the Grasshopper desktop app."
                },
                {
                    name: 'Instant Response',
                    tooltip: 'Automatically send a text to new callers when you can’t answer their call.'
                },
                {
                    name: 'Custom Greetings',
                    tooltip: 'Record professional messages that welcome your customers when they call.'
                }
            ],
            [
                {
                    name: 'Call Transfers',
                    tooltip: 'Place callers on hold and even transfer them to another number when needed.'
                },
                {
                    name: 'Simultaneous Call Handling',
                    tooltip: 'Ensure that your callers never hear a busy signal.'
                },
                {
                    name: 'Incoming Call Control',
                    tooltip: 'Screen callers, block calls and set up custom schedules for your business hours.'
                },
                {
                    name: 'Reporting',
                    tooltip: 'Keep your finger on the pulse of your business with detailed call reports.'
                }
            ]
        ];
    }

    return featureChecklist;
};

// New Pricing Page Features GOTOCOM-5371
export const features = [
    {
        name: 'Users and Phone Numbers',
        rows: [
            {
                name: 'Number of Users',
                tooltip: "With plans for one or many users, you're in control. You can set permissions for each user and grant or restrict access to certain features.",
                trueSolo: {
                    value: 1
                },
                soloPlus: {
                    value: 'Unlimited',
                    highlight: true
                },
                // GOTOCOM-6255 :: Partner Values Hidden
                // partner: {
                //     value: 'Unlimited',
                //     highlight: true
                // },
                smallBiz: {
                    value: 'Unlimited',
                    highlight: true
                }
            },
            {
                name: 'Business Phone Numbers',
                tooltip: <Fragment><p>You can select multiple numbers in different area codes, or select a combination of Toll Free and local!</p>
                    <p>Call and send texts from any of your numbers.</p><p>Pick one now, and add any additional numbers after checkout.</p>
                </Fragment>,
                trueSolo: {
                    value: 1
                },
                soloPlus: {
                    value: 1
                },
                // GOTOCOM-6255 :: Partner Values Hidden
                // partner: {
                //     value: 3
                // },
                smallBiz: {
                    value: 4
                }
            },
            {
                name: 'Additional Phone Numbers',
                sideNote: 'Add-on',
                tooltip: '',
                trueSolo: {
                    value: '$9/month each',
                    monthlyValue: '$10/month each'
                },
                soloPlus: {
                    value: '$9/month each',
                    monthlyValue: '$10/month each'
                },
                smallBiz: {
                    value: '$9/month each',
                    monthlyValue: '$10/month each'
                }
            },
            {
                name: 'Extensions',
                tooltip: 'Extensions can forward to any phone number you choose - or they can all forward to you! ',
                trueSolo: {
                    value: 1
                },
                soloPlus: {
                    value: 3
                },
                // GOTOCOM-6255 :: Partner Values Hidden
                // partner: {
                //     value: 6
                // },
                smallBiz: {
                    value: <Fragment><span className={styles['feature-data--highlight']}>Unlimited</span></Fragment>
                }
            },
            {
                name: 'Additional Extensions',
                sideNote: 'Add-on',
                trueSolo: {
                    value: 'Not available'
                },
                soloPlus: {
                    value: '$3/month each',
                    monthlyValue: '$5/month each'
                },
                smallBiz: {
                    value: <Fragment><span className={styles['feature-data--highlight']}>Unlimited</span></Fragment>
                }
            }
        ]
    },
    {
        name: 'Core Features',
        rows: [
            {
                name: '24/7 Support',
                tooltip: 'We’re here to help! Get 24/7 support access via phone, email, Twitter, Facebook and chat!',
                allCheck: true
            },
            {
                name: 'Business Texting',
                sideNote: 'Registration required',
                tooltip: <Fragment>Provide updates and quick replies via text messaging on your business number. Requires registration with carriers before sending texts. <a href="https://support.grasshopper.com/help/register-your-phone-numbers-for-sms-compliance" target="_blank">Click here to learn more.</a></Fragment>,
                trueSolo: {
                    value: 'Unlimited'
                },
                soloPlus: {
                    value: 'Unlimited'
                },
                // GOTOCOM-6255 :: Partner Values Hidden
                // partner: {
                //     value: 'Unlimited'
                // },
                smallBiz: {
                    value: 'Unlimited'
                },
                subFeatures: [
                    {
                        name: 'Local Number Registration + Messaging Fee',
                        tooltip: <Fragment><p>One-time fees consist of $4 to register your company with The Campaign Registry and $15 for carriers to review your SMS use case.</p>
                            <p>The Campaign Registry also charges a monthly fee based on your use case to help you remain in compliance with the carriers that deliver messages. <a href="https://support.grasshopper.com/help/register-your-brand-and-sms-for-10dlc-sms-compliance" target="_blank">Learn More</a></p>
                        </Fragment>,
                        trueSolo: {
                            value: <Fragment>$19 one-time
                                <div>+$1.50/month</div>
                            </Fragment>
                        },
                        soloPlus: {
                            value: <Fragment>$19 one-time
                                <div>+$1.50/month</div>
                            </Fragment>
                        },
                        // GOTOCOM-6255 :: Partner Values Hidden
                        // partner: {
                        //     value: <Fragment>$19 one-time
                        //         <div>+$1.50/month</div>
                        //     </Fragment>
                        // },
                        smallBiz: {
                            value: <Fragment>$19 one-time
                                <div>+$1.50/month</div>
                            </Fragment>
                        }
                    },
                    {
                        name: 'Toll-Free Number Registration',
                        tooltip: <Fragment>Due to industry compliance requirements, registration required for toll-free numbers before sending text messages. <a href="https://support.grasshopper.com/help/register-your-phone-numbers-for-sms-compliance" target="_blank">Click here to learn more.</a></Fragment>,
                        trueSolo: {
                            value: <Fragment>Registration Only
                                <div>(No Fee)</div>
                            </Fragment>
                        },
                        soloPlus: {
                            value: <Fragment>Registration Only
                                <div>(No Fee)</div>
                            </Fragment>
                        },
                        // GOTOCOM-6255 :: Partner Values Hidden
                        // partner: {
                        //     value: <Fragment>Registration Only
                        //         <div>(No Fee)</div>
                        //     </Fragment>
                        // },
                        smallBiz: {
                            value: <Fragment>Registration Only
                                <div>(No Fee)</div>
                            </Fragment>
                        }
                    }
                ]
            },
            {
                name: 'Mobile + Desktop Apps',
                tooltip: 'Stay connected with Grasshopper on your desktop, iPhone or Android device.',
                allCheck: true
            },
            {
                name: 'Call Forwarding',
                tooltip: 'Route business calls to your personal phone or to another team member.',
                allCheck: true
            },
            {
                name: 'Call Recording',
                tooltip: 'Set up automatic recording for all inbound calls, all outbound calls, or both. Available on every extension.',
                trueSolo: {
                    value: 'Not available'
                },
                soloPlus: {
                    check: true
                },
                smallBiz: {
                    check: true
                }
            },
            {
                name: 'VoIP + WiFi Calling',
                tooltip: 'Use your internet connection to make and receive calls when cell reception is poor.',
                allCheck: true
            },
            {
                name: 'Virtual Fax',
                tooltip: 'Have incoming faxes delivered as PDF attachments right to your email inbox.',
                allCheck: true
            },
            {
                name: 'Voicemail',
                tooltip: 'Set up a voicemail for business calls and get voicemail recording sent to your email.',
                allCheck: true
            },
            {
                name: 'Read Your Voicemail',
                tooltip: 'Get your voicemails transcribed so you can read them without having to listen to the message!',
                allCheck: true
            },
            {
                name: 'Instant Response',
                tooltip: 'Automatically send a text to new callers when you can’t answer their call.',
                allCheck: true
            },
            {
                name: 'Custom Greetings',
                tooltip: 'Record professional messages that welcome your customers when they call.',
                allCheck: true
            },
            {
                name: 'Call Transfers',
                tooltip: 'Place callers on hold and even transfer them to another number when needed.',
                trueSolo: {
                    value: 'Not available'
                },
                soloPlus: {
                    check: true
                },
                smallBiz: {
                    check: true
                }
            },
            {
                name: 'Simultaneous Call Handling',
                tooltip: 'Ensure that your callers never hear a busy signal.',
                trueSolo: {
                    value: 'Not available'
                },
                soloPlus: {
                    check: true
                },
                smallBiz: {
                    check: true
                }
            },
            {
                name: 'Incoming Call Control',
                tooltip: 'Screen callers, block calls and set up custom schedules for your business hours.',
                allCheck: true
            },
            {
                name: 'Reporting',
                tooltip: 'Keep your finger on the pulse of your business with detailed call reports.',
                allCheck: true
            }
        ]
    }
];
